import PageHeader from "@/components/page-header";
import { HelpCatalog } from "@/components/registrant/help/help-portal";
import { GOVERNMENT_HELP_PORTAL } from "@/lib/government-help";
import { createFileRoute } from "@tanstack/react-router";
import { useState } from "react";

export const Route = createFileRoute("/government/help/")({
  component: GovernmentHelpIndex,
});

function GovernmentHelpIndex() {
  const [search, setSearch] = useState("");
  return (
    <div className="flex w-full flex-col">
      <PageHeader
        title="Help Center"
        subtitle="Search or browse topics for the government portal"
        className="mb-6"
      />
      <HelpCatalog
        search={search}
        onSearchChange={setSearch}
        catalog={GOVERNMENT_HELP_PORTAL}
      />
    </div>
  );
}
